<template>
  <modal @close="close" width="70%">
    <component
      :is="!isExtranet ? 'binnacle' : 'extranet-binnacle'"
      :affectedId="affectedId"
      v-if="affectedId"
    />
  </modal>
</template>

<script>

import sinisterService from '@/services/sinister'
import Binnacle from '@/pages/RoadSinisters/File/Binnacle'

const ExtranetBinnacle = () => import("@/pages/extranet/Binnacle");

export default {

  name: 'BinnacleModal',

  props: {
    realPlan: {
      type: Object,
      required: true,
    },
    isExtranet: {
      type: Boolean,
      required: true
    }
  },

  components: {
    Binnacle,
    ExtranetBinnacle
  },

  methods: {
    close() {
      this.$emit('close')
    },
    fetchSinister() {
      const { sinisterId: id, isExtranet: isCustomer } = this
      sinisterService.fetch({
        id, isCustomer
      }).then(
        roadSinister => this.roadSinister = roadSinister)
    },
  },

  computed: {
    sinisterId() {
      const realPlan = this.realPlan
      const planExpected = realPlan && realPlan.planExpected
      return planExpected && planExpected.roadSinisterId
    },
    affectedId() {
      const roadSinister = this.roadSinister
      return roadSinister ? roadSinister.affected.id : null
    },
  },

  watch: {
    sinisterId: {
      immediate: true,
      handler(id) {
        if (!id) return

        this.fetchSinister()
      }
    },
  },

  data () {
    return {
      roadSinister: null,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/BinnacleModal.vue